var _circle, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRank3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#BAF7D3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    transform: "translate(6.00195 6)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1948 11.937C18.7851 11.521 18.1194 11.521 17.7098 11.937L13.9298 15.7904L12.2942 14.123C12.0893 13.9142 11.8209 13.8098 11.5525 13.8098C11.2825 13.8098 11.0141 13.9142 10.8092 14.123C10.3995 14.5406 10.3995 15.2193 10.8092 15.6368L13.1879 18.0618C13.3866 18.2627 13.6488 18.375 13.9296 18.375C14.2104 18.375 14.4742 18.2627 14.6729 18.0618L19.1946 13.4507C19.6044 13.0347 19.6044 12.3545 19.1948 11.937Z",
    fill: "#0E7C3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank3);
export default __webpack_public_path__ + "static/media/Rank-3.ae91be73014b7b40e7443eba82632c3c.svg";
export { ForwardRef as ReactComponent };